"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var parseAndFormatText = function parseAndFormatText(text) {
  var elements = [];
  var lines = text.split("\n");
  var unorderedListItems = [];
  var orderedListItems = [];
  lines.forEach(function (line, index) {
    if (!line.trim()) return; // Skip empty lines
    // Handle formatting replacements

    line = line.replace(/\*\*\*(.*?)\*\*\*/g, "<em><strong>$1</strong></em>"); // Bold + Italic

    line = line.replace(/\*\*(.*?)\*\*/g, "$1"); // ** Remove unwanted bold

    line = line.replace(/\*(.*?)\*/g, "<em>$1</em>"); // Italic

    line = line.replace(/__(.*?)__/g, "<u>$1</u>"); // Underline

    line = line.replace(/~~(.*?)~~/g, "<del>$1</del>"); // Strikethrough

    line = line.replace(/`(.*?)`/g, "<code class='summary-text'>$1</code>"); // Inline Code
    // Handle Email Links

    line = line.replace(/([\w\.-]+@[\w\.-]+\.\w+)/g, '<a href="mailto:$1">$1</a>'); // Handle Hyperlinks [text](url)

    line = line.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>'); // ** Dynamically Bold Only Attribute Labels **

    line = line.replace(/^([\w\s/]+?):\s/, "<strong>$1:</strong> "); // Only bold labels at the start
    // Handle Blockquotes "> Text"

    if (line.startsWith("> ")) {
      elements.push( /*#__PURE__*/_react["default"].createElement("blockquote", {
        key: index,
        className: "summary-text"
      }, line.substring(2)));
      return;
    } // Handle Code Blocks """ code """


    if (line.startsWith("'''") || line.startsWith('"""')) {
      elements.push( /*#__PURE__*/_react["default"].createElement("pre", {
        key: index,
        className: "summary-text"
      }, /*#__PURE__*/_react["default"].createElement("code", null, line.replace(/['"`]/g, ""))));
      return;
    } // Handle Numbered Lists (1. Item)


    if (/^\d+\./.test(line)) {
      orderedListItems.push(line.substring(3));
      return;
    } else if (orderedListItems.length) {
      elements.push( /*#__PURE__*/_react["default"].createElement("ol", {
        key: "ol-" + index
      }, orderedListItems.map(function (item, idx) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: idx,
          className: "summary-text"
        }, item);
      })));
      orderedListItems = [];
    } // Handle Unordered Lists "- Item" or "* Item"


    if (line.startsWith("- ") || line.startsWith("* ")) {
      unorderedListItems.push(line.substring(2));
      return;
    } else if (unorderedListItems.length) {
      elements.push( /*#__PURE__*/_react["default"].createElement("ul", {
        key: "ul-" + index
      }, unorderedListItems.map(function (item, idx) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: idx,
          className: "summary-text"
        }, item);
      })));
      unorderedListItems = [];
    }

    elements.push( /*#__PURE__*/_react["default"].createElement("p", {
      key: index,
      className: "summary-text",
      dangerouslySetInnerHTML: {
        __html: line
      }
    }));
  }); // Close any remaining lists

  if (unorderedListItems.length) {
    elements.push( /*#__PURE__*/_react["default"].createElement("ul", {
      key: "last-ul"
    }, unorderedListItems.map(function (item, idx) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: idx,
        className: "summary-text"
      }, item);
    })));
  }

  if (orderedListItems.length) {
    elements.push( /*#__PURE__*/_react["default"].createElement("ol", {
      key: "last-ol"
    }, orderedListItems.map(function (item, idx) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: idx,
        className: "summary-text"
      }, item);
    })));
  }

  return elements;
};

var SummaryView = function SummaryView(_ref) {
  var summaryData = _ref.summaryData;
  return /*#__PURE__*/_react["default"].createElement("div", null, parseAndFormatText(summaryData === null || summaryData === void 0 ? void 0 : summaryData.text));
};

var _default = SummaryView;
exports["default"] = _default;